<template>
  <div
    class="custom-select"
    :class="[
      inputWidthHeightClass,
      borderClass,
      { relative: !shouldExpand },
      { ' overflow-hidden': hasNameAvatar },
    ]"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div
      class="selected flex"
      :class="[inputWidthHeightClass, isClassOpen, borderClass]"
      @click="open = !open"
    >
      <img v-if="selected.logo" :src="resizer(selected.logo)" class="rounded-full w-30 h-30" />
      <name-avatar class="w-30" v-else-if="hasNameAvatar" size="30" :text="selected.name" />
      <div
        v-if="!hasNameAvatar"
        :class="{ 'text-disabled': !disabled }"
        dir="auto"
        class="truncate flex-1 px-3 text-title text-sm"
      >
        {{ selected.name ? selected.name : placeholder }}
      </div>
      <div class="mx-5" v-if="disabled">
        <arrow-icon :class="{ arrow: open }" />
      </div>
    </div>
    <div
      class="items"
      v-if="disabled"
      :style="{ width: `${dropDownWidth}%` }"
      :class="{ selectHide: !open }"
    >
      <slot name="text" />
      <div>
        <div
          v-for="(option, i) of options"
          :key="i"
          :class="[borderClass]"
          class="flex gap-x-10 items-center hover:bg-tertiary rounded mx-5 disabled-div"
          @click="
            selected = option;
            open = false;
            $emit('input', option);
          "
          :disabled="option.admin_check === 1
           && option.id !== defaultOptionId && type === 'edit'"
        >
          <img
            v-if="option.logo"
            :src="resizer(option.logo)"
            alt=""
            class="rounded-full w-30 h-30"
          />
          <name-avatar v-else-if="hasNameAvatar" size="30" :text="option.name" />
          <div class="w-full flex justify-between items-center rounded">
            <p class="whitespace-nowrap truncate text-title">
              {{ option.name }}
            </p>
            <security-icon color="#007AFF" v-if="hasIcon && option.admin_check === 1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowIcon from '@/assets/icons/vue/arrow_down.vue';
import NameAvatar from '@/components/base/BaseNameAvatar.vue';
import imageResizer from '@/utils/image-resizer';
import SecurityIcon from '@/assets/icons/vue/SecurityIcon.vue';

export default {
  components: { ArrowIcon, NameAvatar, SecurityIcon },
  props: {
    hasNameAvatar: {
      type: Boolean,
      default: false,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    width: {
      type: String,
      default: 'full',
    },
    height: {
      type: String,
      default: '68',
    },
    radius: {
      type: String,
      default: 'sm',
    },
    default: {
      type: Object,
      default() {
        return {};
      },
      required: false,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    shouldExpand: {
      type: Boolean,
      required: false,
      default: false,
    },
    dropDownWidth: {
      type: Number,
      default: 100,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: '',
    },
  },
  watch: {
    default(val) {
      this.defaultOptionId = val.id;
      this.selected = this.default;
    },
  },
  computed: {
    inputWidthHeightClass() {
      if (this.hasNameAvatar) {
        return `w-102 h-${this.height}`;
      }
      return `w-${this.width} h-${this.height}`;
    },
    isClassOpen() {
      return { open: this.open };
    },
    borderClass() {
      return {
        rounded: this.radius === 'default',

        'rounded-sm': this.radius === 'sm',
      };
    },
  },
  data() {
    return {
      selected: '',
      open: false,
      imageSize: 150,
      defaultOptionId: -1,
    };
  },
  mounted() {
    if (this.default) {
      this.selected = this.default;
    } else {
      this.selected = this.options[0];
    }
  },
  methods: {
    resizer(image) {
      return imageResizer(image, this.imageSize);
    },
  },
};
</script>

<style scoped>
.disabled-div[disabled] {
  opacity: 0.2;
  pointer-events: none;
}
.custom-select {
  @apply text-left outline-none bg-secondary cursor-pointer;
}
.custom-select:is(:lang(fa), :lang(ar)) {
  @apply text-right;
}
.custom-select .selected {
  @apply py-5 px-10 text-18 font-normal flex items-center sm:text-12 text-subtitle;
}
.custom-select .items {
  @apply absolute bg-secondary rounded-b z-20 shadow-2xl max-h-200
    overflow-y-scroll left-0 right-0 text-subtitle;
}
.custom-select .items div div {
  @apply text-subtitle px-10 cursor-pointer py-8;
  user-select: none;
}
.selectHide {
  @apply hidden;
}
.arrow {
  @apply top-15;
  transform: rotate(-180deg);
}
</style>
